(function($){
    Drupal.behaviors.mo43 = {
        attach() {
            $(once('mo43', 'body')).first().each(function() {
                var $headerDownloadButton = $('#MO43-download-button');
                const $formContainer = $('.docbinder-download-form');
                const $startedContainer = $('.download-page__started-container');
                const $downloadContainer = $('.download-page');
                const $files = $('.download-collection');

                if ($downloadContainer.length) {
                    $headerDownloadButton.click(function(){
                        var $downloadForm = $("#docbinder-download-form");
                        $downloadForm.submit();
                    });

                    if ($files.length) {
                        $downloadContainer.addClass('download-page--has-files');
                    }

                    $(document).on('submit','#docbinder-download-form',function(){
                        $startedContainer.height($formContainer.height());
                        $downloadContainer.removeClass('download-page--has-files');
                        $downloadContainer.addClass('download-page--started');
                    });
                }
            });
        }
    }
})(jQuery);
